export const FETCH_FOLLOWING_USER_STORY="FETCH_FOLLOWING_USER_STORY";
export const FETCH_USER_STORY="FETCH_USER_STORY"